import { useEffect } from "react";

/**
 * Injecte un bloc de données structurées schema.org dans le <head> le temps
 * de la vie du composant. Utilisé par les pages rendues côté client ; le
 * balisage de la page d'accueil, lui, est écrit en dur dans index.html.
 */
export default function JsonLd({ id, data }) {
    useEffect(() => {
        const el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        el.textContent = JSON.stringify(data);
        document.head.appendChild(el);
        return () => el.remove();
    }, [id, data]);

    return null;
}
